package theme

object ImageRefs {
    const val logoRefLightMode = "/images/logo_new.png"
}